import React, { useEffect, useState } from "react";
import { Rating } from "react-simple-star-rating";
import Pagination from "../pagination/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { http } from "../../helpers/http";
import { useOutletContext, useLocation } from "react-router-dom";
import moment from "moment";
import { updateRestaurantReviews } from "../../redux/actions/generalActions";

function Reviews() {
  // let location = useLocation();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const reviews = useSelector((state) => state.general.reviews);
  const { outletId } = useOutletContext();

  const getRestaurantReviews = () => {
    let apiParams = new URLSearchParams();
    apiParams.append("outletId", outletId);
    apiParams.append("page", page);
    apiParams.append("size", 10);
    apiParams = `?${apiParams.toString()}`;

    http(
      {
        method: "GET",
        url: `getRating${apiParams}`,
        isSecure: true,
      },
      (res) => {
        if (res.error === "false") {
          dispatch(updateRestaurantReviews(res.reviews));
        }
      }
    );
  };

  useEffect(() => {
    outletId && getRestaurantReviews();
  }, [outletId, page]);

  return (
    <>
      <div className="review-info">
        {reviews.length && <h2 className="head6">Reviews</h2>}
        {reviews.data?.length ? (
          reviews.data.map((item) => (
            <div key={item.id} className="review-box">
              <div className="user">
                <img
                  src={item?.image || "./assets/img/main_bannerImg.png"}
                  alt="start"
                />
              </div>
              <div className="user-content">
                <h2 className="head6">
                  {item?.userName}
                  <Rating initialValue={item?.orderRating} readonly size={15} className="ms-1" />
                </h2>
                <p>{item?.feedback}</p>
                <span>{moment(item?.updated_at).format("LLL")}</span>
              </div>
            </div>
          ))
        ) : (
          <h5 className="text-center">No reviews yet!</h5>
        )}
      </div>
      {reviews.last_page > 1 && (
        <Pagination
          totalPages={reviews?.last_page}
          currentPage={reviews?.current_page}
          page={page}
          setPage={(page) => setPage(page)}
          flexPosition="justify-content-end"
        />
      )}
    </>
  );
}

export default Reviews;
